import { atom } from "recoil"

// 회원 가입 단계는 1, 2, 3의 값만 가질 수 있음
type signupStepType = 1 | 2 | 3

const signupStepState = atom<signupStepType>({
  key: "signupStepState",
  default: 1,
})

export default signupStepState
